import { ASSETS_API_URL } from "config/api";
import { showApiError } from "config/apiToast";
import { getApiErrorMessages } from "config/apiErrors";
import React, { useEffect, useState } from "react";
import "./dashboard.scss";
import { Modal, Nav, Pagination } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { RemoveShoppingCartOutlined } from "@material-ui/icons";
import { MARKETS_MAX_PAGE_LIMIT } from "./marketFields";



const Market = () => {

  const [tasks, setTasks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // GET /markets rejects a limit above 20.
  const [itemsPerPage] = useState(Math.min(10, MARKETS_MAX_PAGE_LIMIT));
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const getData = async (page, limit) => {
    const tok = localStorage.getItem("accessTokenDash");
    setTasks([]);
    setLoading(true);
    setLoadError("");

    var config = {
      method: "get",
      url: `${ASSETS_API_URL}/markets?page=${page}&limit=${limit}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };

    axios(config)
      .then(function (response) {
        setTasks(response?.data?.data || []); // Assuming the tasks array is nested inside data
        setTotalPages(response?.data?.pagination?.pageCount || 1); // Assuming the total page count is returned
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        setLoadError(getApiErrorMessages(error).join(" "));
      })
      .finally(function () {
        setLoading(false);
      });
  };


  const deleteToken = async (id) => {
    console.log(id)
    const tok = localStorage.getItem("accessTokenDash");
    // setTasks([]);

    var config = {
      method: "delete",
      url: `${ASSETS_API_URL}/markets/${id}`,
      headers: {
        authorization: `Bearer ${tok}`
      },
    };

    axios(config)
      .then(function (response) {
        console.log("responce", response)
        getData(currentPage, itemsPerPage);
        // setTasks(response?.data?.data); // Assuming the tasks array is nested inside data
        // setTotalPages(response?.data?.pagination?.pageCount); // Assuming the total page count is returned
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
        showApiError(error);
      });
  };


  useEffect(() => {
    getData(currentPage, itemsPerPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  return (
    <>
      <img className="elipse img-fluid" src="\assets\main-assets\Ellipse.png" />
      <div className="content">
        <div className="maintablea_task">
          <div class="table-responsive  maintable">
            <table>
              <thead>
                <th>Markets </th>
                <th>Token symbol</th>
                <th>Decimals</th>
                <th>Listed</th>
                <th>Available</th>
                <th>Details</th>
                {/* <th>Action</th> */}
              </thead>
              <tbody>
                {loading && (
                  <tr><td colSpan="6"><p className="white">Loading markets...</p></td></tr>
                )}
                {!loading && loadError && (
                  <tr><td colSpan="6"><p className="error">{loadError}</p></td></tr>
                )}
                {!loading && !loadError && tasks?.length === 0 && (
                  <tr><td colSpan="6"><p className="white">No markets found.</p></td></tr>
                )}
                {tasks?.map((task) => (
                  <tr key={task?.id}>
                    <td>
                      <div className="para11">
                        <img className="edfeveerverre img-fluid" src={task?.icon} alt={task.name} />
                        {task.name}
                      </div>
                    </td>
                    <td className="tdofbtcc">{task?.symbol}</td>
                    <td className="tdofbtcc">{task?.decimals === null || task?.decimals === undefined ? "-" : task?.decimals}</td>
                    <td>
                      {task?.isListed ? <p className="yesclass1">Yes</p> : <p className="yesclass2">No</p>}
                    </td>
                    <td>
                      {task?.isAvailable ? <p className="yesclass1">Yes</p> : <p className="yesclass2">No</p>}
                    </td>
                    <td>
                      <Link to={`marketdetails?ids=${task?.id}`}>
                        <button className="dettailsbut">Details</button>
                      </Link>
                    </td>
                    {/* <td>
                      <button onClick={() => deleteToken(task?.id)} type="button" className="dettailsbut">Delete</button>
                    </td> */}
                  </tr>
                ))}
                {/* <tr>
                  <td>
                    <div className="para11">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="29"
                        viewBox="0 0 28 29"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_8_273)">
                          <path
                            d="M14 28.5C21.732 28.5 28 22.232 28 14.5C28 6.76801 21.732 0.5 14 0.5C6.26801 0.5 0 6.76801 0 14.5C0 22.232 6.26801 28.5 14 28.5Z"
                            fill="#627EEA"
                          />
                          <path
                            d="M14.4358 4V11.7613L20.9957 14.6925L14.4358 4Z"
                            fill="white"
                            fill-opacity="0.602"
                          />
                          <path
                            d="M14.4357 4L7.875 14.6925L14.4357 11.7613V4Z"
                            fill="white"
                          />
                          <path
                            d="M14.4358 19.7221V24.9957L21 15.9141L14.4358 19.7221Z"
                            fill="white"
                            fill-opacity="0.602"
                          />
                          <path
                            d="M14.4357 24.9957V19.7212L7.875 15.9141L14.4357 24.9957Z"
                            fill="white"
                          />
                          <path
                            d="M14.4358 18.5013L20.9957 14.6924L14.4358 11.7629V18.5013Z"
                            fill="white"
                            fill-opacity="0.2"
                          />
                          <path
                            d="M7.875 14.6924L14.4357 18.5013V11.7629L7.875 14.6924Z"
                            fill="white"
                            fill-opacity="0.602"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_8_273">
                            <rect
                              width="28"
                              height="28"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      Ethereum
                    </div>
                  </td>
                  <td className="tdofbtcc">ETHUSDT</td>
                  <td>
                    <p className="yesclass2">No</p>
                  </td>
                  <td>
                    <p className="yesclass2">No</p>
                  </td>
                  <td>
                    <button className="dettailsbut">Details</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="para11">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="29"
                        viewBox="0 0 28 29"
                        fill="none"
                      >
                        <path
                          d="M27.5812 17.8867C25.7114 25.3867 18.115 29.9511 10.614 28.0809C3.11623 26.2111 -1.44817 18.6142 0.422453 11.1148C2.29143 3.61387 9.88779 -0.950873 17.3864 0.918928C24.8869 2.78873 29.451 10.3864 27.581 17.8868L27.5811 17.8867H27.5812Z"
                          fill="#F7931A"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M20.175 12.5054C20.4537 10.6423 19.0353 9.64081 17.0957 8.97272L17.7249 6.449L16.1886 6.0662L15.5761 8.52348C15.1722 8.42275 14.7574 8.32783 14.3452 8.23374L14.9622 5.76024L13.4269 5.37744L12.7973 7.90035C12.4631 7.82425 12.1348 7.74904 11.8164 7.6698L11.8181 7.66186L9.69959 7.13283L9.29093 8.77366C9.29093 8.77366 10.4307 9.03493 10.4067 9.05101C11.0288 9.20628 11.1413 9.61809 11.1226 9.94451L10.4059 12.8196C10.4487 12.8305 10.5043 12.8462 10.5656 12.8709L10.521 12.8597C10.4831 12.8503 10.4437 12.8404 10.4032 12.8307L9.39857 16.8583C9.32254 17.0473 9.12957 17.331 8.69462 17.2233C8.71002 17.2456 7.57804 16.9446 7.57804 16.9446L6.81531 18.7032L8.81451 19.2015C9.03341 19.2564 9.24973 19.3128 9.46385 19.3686L9.46394 19.3687C9.61359 19.4077 9.76217 19.4464 9.90981 19.4842L9.27409 22.0368L10.8086 22.4196L11.4381 19.8941C11.8574 20.0079 12.2642 20.1128 12.6624 20.2118L12.035 22.7254L13.5713 23.1083L14.207 20.5604C16.8267 21.0562 18.7964 20.8563 19.6255 18.4868C20.2936 16.5791 19.5923 15.4787 18.2141 14.7611C19.2179 14.5296 19.974 13.8694 20.1756 12.5056L20.1751 12.5053L20.175 12.5054ZM16.665 17.4273C16.2294 19.1776 13.4898 18.454 12.2363 18.1229C12.1235 18.0931 12.0228 18.0665 11.9369 18.0452L12.7805 14.6634C12.8852 14.6895 13.0132 14.7182 13.1582 14.7508L13.1582 14.7508C14.4548 15.0417 17.1113 15.6379 16.6651 17.4273H16.665ZM13.4183 13.1812C14.4633 13.4601 16.7431 14.0685 17.1401 12.4777H17.1403C17.5457 10.8508 15.3302 10.3603 14.2481 10.1207C14.1264 10.0937 14.019 10.07 13.9313 10.0481L13.1664 13.1152C13.2386 13.1332 13.3234 13.1559 13.4183 13.1812Z"
                          fill="white"
                        />
                      </svg>{" "}
                      Bitcoin
                    </div>
                  </td>
                  <td className="tdofbtcc">BTCUSDT</td>
                  <td>
                    <p className="yesclass1">Yes</p>
                  </td>
                  <td>
                    <p className="yesclass1">Yes</p>
                  </td>
                  <td>
                    <Link to="/tokendetails" className="dettailsbut">
                      Details
                    </Link>
                  </td>
                </tr> */}
              </tbody>
            </table>
            <div className="Paginationlattable">
              <div>
                <p className="showclasss">
                  SHOWING {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, tasks.length)} OF {tasks.length}
                </p>
              </div>
              <div className="pagitwo">
                <button className="leftpigbtn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      d="M10 13L5 8L10 3"
                      stroke="#565656"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <Pagination>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
                      {index + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
                <button className="leftpigbtnn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      d="M5 13L10 8L5 3"
                      stroke="#565656"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Market;
